var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { View } from 'react-native';
import { SmallView } from '../Typography/SmallView';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { getColorScheme } from '../../Hooks/UseColorScheme';
let ChatItemView = class ChatItemView extends Component {
    render() {
        var _a, _b, _c;
        return (_jsx(View, { style: [(_a = this.props.style) === null || _a === void 0 ? void 0 : _a.container, !this.props.leftAlign && ((_b = this.props.style) === null || _b === void 0 ? void 0 : _b.endAlignedContainer), this.props.containerStyle], children: _jsx(SmallView, { textStyle: (_c = this.props.style) === null || _c === void 0 ? void 0 : _c.text, children: this.props.children }) }));
    }
};
ChatItemView = __decorate([
    component({
        provider: CoreConfig.provider,
        moduleName: CoreConfig.moduleName,
        componentName: Configuration.ComponentNames.chatItem,
        style() {
            return {
                container: {
                    padding: 12,
                    borderBottomStartRadius: 8,
                    borderBottomEndRadius: 8,
                    borderTopEndRadius: 8,
                    backgroundColor: getColorScheme().value.scheme === 'dark'
                        ? '#141414'
                        : '#F0F3F7',
                },
                endAlignedContainer: {
                    alignItems: 'flex-end',
                    borderTopStartRadius: 8,
                    borderTopEndRadius: 0
                },
                text: {
                    flexShrink: 1,
                    fontSize: 15,
                    lineHeight: 22
                }
            };
        }
    })
], ChatItemView);
export { ChatItemView };
